import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/medical-service-provider/doctors/`;

export const doctors = {
  getAll: () => generateApiPath(pathBase),
};
